// Keep in sync with @msys/pdf-utils pdfUnits.ts
export const PDF_UNITS = ["pt", "mm", "cm", "in"];
//# sourceMappingURL=pdfUnits.js.map